<div class="host-cleaner-assign-picker">
  <div
    class="picker"
    nz-dropdown
    nzTrigger="click"
    [nzBackdrop]="false"
    [nzDropdownMenu]="menu"
    [(nzVisible)]="visible"
  >
    <span class="text-view" [class.placeholder]="!textView">{{ textView || placeholder }}</span>
    <i
      nz-icon
      style="margin-left: 5px"
      [nzType]="visible ? 'caret-up' : 'caret-down'"
      nzTheme="outline"></i>
  </div>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="cleaner-assign-picker-dropdown-panel">
      <div class="header">
        <div class="list">
          <div
            class="label"
            [class.selected]="selectedGroup === group.id"
            *ngFor="let group of groupList"
            (click)="onSelectGroup(group)">{{ group.name }}</div>
        </div>
      </div>

      <div class="content">
        <div class="list">
          <div
            class="label"
            [class.selected]="selectedStaff.has(staff.value)"
            *ngFor="let staff of staffListOfGroup"
            (click)="onSelectStaff(staff)">{{ staff.label }}</div>
        </div>
      </div>

      <div class="footer">
        <div class="left"></div>
        <div class="center">
          <button nz-button (click)="onCancel()">{{ "word.cancel" | translate }}</button>
          <button nz-button nzType="primary" (click)="onConfirm()">{{ "word.confirm" | translate }}</button>
        </div>
        <div class="right">
          <a href="javascript:void(0)" class="reset" (click)="onReset()">{{ "word.reset_filter" | translate }}</a>
        </div>
      </div>
    </div>
  </nz-dropdown-menu>
</div>
